import StatusView from '../Status/StatusView'
import { countRejectedRequests, RejectedRequestBadgedLabel } from '../Status/RejectedRequestBadgedLabel'
import { AssignmentRequestActions } from '../AssignmentRequests/ButtonsAssignmentRequestActions'
import { stdDateHelper } from '../../Utils/DateUtils'
import { RequestReferenceItem } from './ReferenceItem'
import { IRequestTableData } from './RequestsTable'
import { Link } from 'react-router-dom'
import { Darwin } from '@nic/nic-api/types'
import { IReferenceContact } from '@nic/nic-api/types/Darwin/types'
import { Typography } from 'antd'
import { Div } from '@nic/ui-comps'

const { Text } = Typography

export const requestsTableRegistrar = (router: any, data: any, keycloak: any) => {
  // Creiamo una mappa per memorizzare i dati già calcolati per ogni riga
  const rowCache = new Map<number, any>()

  const getRow = (id: number) => {
    if (!rowCache.has(id)) {
      rowCache.set(id, data?.find((d: any) => d.id === id))
    }
    return rowCache.get(id)
  }


  return {
    id: (id: number) => <Link to={`${router.pathname}/${id}`}>{id}</Link>,
    status: (status: Darwin.RequestStatus, record: IRequestTableData) => {
      return <StatusView status={status} />
    },
    extra: (status: Darwin.RequestStatus, record: IRequestTableData) => {
      if (['pending', 'registrarUpdated'].includes(status)) {
        const currentRow = getRow(record.id)
        return (
          <RejectedRequestBadgedLabel count={countRejectedRequests(currentRow?.events as any)} />
        )
      }
      return <></>
    },
    action: (text: any, record: IRequestTableData) => {
      const currentRow = getRow(record.id)
      if (currentRow?.status === 'pending' || currentRow?.status === 'registrarUpdated') {
        const isRegistrarAssignedUser = keycloak?.tokenParsed?.userId === currentRow?.registrarUser?.id

        return (
          <div style={{ float: 'right' }}>
            <AssignmentRequestActions
              disableAssignToMeButton={isRegistrarAssignedUser}
              disableAssignToUserButton={false}
              disableReleaseButton={!isRegistrarAssignedUser}
              requestId={record.id}
              flash={!isRegistrarAssignedUser}
            />
          </div>
        )
      } else {
        return <></>
      }
    },
    created: (created: string) => <span>{stdDateHelper(created)}</span>,
    referenceContact: (referenceContact: IReferenceContact) => {
      return (
        referenceContact && (
          <div style={{ minWidth: '200px' }}>{RequestReferenceItem(referenceContact)}</div>
        )
      )
    },
    domains: (value: number, record: IRequestTableData) => (
      <div style={{ textAlign: 'right' }}>
        <>{record.domains}</>
      </div>
    ),
    contacts: (value: number, record: IRequestTableData) => (
      <div style={{ textAlign: 'right' }}>
        <>{record.contacts}</>
      </div>
    ),
    registrarUser: (value: Darwin.RegistrarUser, record: IRequestTableData) => {
      const currentRow = getRow(record.id)
      const isRegistrarAssignedUser = keycloak?.tokenParsed?.userId === currentRow?.registrarUser?.id

      return (
        <Div style={{ textAlign: 'center', fontSize: '0.8rem' }}>
          {value ? <Text strong style={{ color: isRegistrarAssignedUser ? '#000000' : '#B2B2B2' }}>{value.username}</Text> : <></>}
        </Div>
      )
    },
  }
}
